// @flow

import type { EmailNotificationsState } from "./types";

export const initialState: EmailNotificationsState = {
  requestsInProgress: 0,
  schema: null,
  list: {
    content: [],
    pagination: {
      offset: 0,
      pageNumber: 0,
      pageSize: 0,
    },
    totalElements: 0,
  },
  current: null,
  edited: null,
  assignments: [],
  modals: {
    modalStep: 1,
    showAddModal: false,
    showEditModal: false,
    showDeleteModal: false,
  },
};

export default initialState;
